'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/axios/lib/cancel/isCancel.js
// module id = 168
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14